import {
  Badge,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  Skeleton,
} from "@pushup/ui";
import { useHealth } from "../hooks/use-health";

export function HealthStatusCard() {
  const { data, isLoading, isError, error } = useHealth();

  return (
    <Card>
      <CardHeader>
        <CardTitle>API status</CardTitle>
        <CardDescription>Live check against the Hono worker and D1 database.</CardDescription>
      </CardHeader>
      <CardContent>
        {isLoading ? (
          <div className="space-y-2">
            <Skeleton className="h-4 w-32" />
            <Skeleton className="h-4 w-48" />
          </div>
        ) : isError ? (
          <div className="space-y-1">
            <Badge variant="destructive">Unreachable</Badge>
            <p className="text-sm text-muted-foreground">
              {error instanceof Error ? error.message : "Could not reach the backend."}
            </p>
          </div>
        ) : data ? (
          <div className="flex items-center gap-3">
            <Badge variant="success">Backend ok</Badge>
            <Badge variant="secondary">DB {data.db}</Badge>
            <span className="text-xs text-muted-foreground">
              v{data.version} · {new Date(data.timestamp).toLocaleTimeString()}
            </span>
          </div>
        ) : null}
      </CardContent>
    </Card>
  );
}
